import React, { Children } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ZapIcon, ShieldCheckIcon, EyeIcon, BrainIcon } from 'lucide-react';
export function UpsellPage() {
  const navigate = useNavigate();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  const bullets = [{
    icon: <ZapIcon className="w-6 h-6 text-brand-gold" data-id="element-367" />,
    text: 'Detecta valor en segundos'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-gold" data-id="element-368" />,
    text: 'Reduce errores'
  }, {
    icon: <EyeIcon className="w-6 h-6 text-brand-gold" data-id="element-369" />,
    text: 'Aplica el método con claridad'
  }, {
    icon: <BrainIcon className="w-6 h-6 text-brand-gold" data-id="element-370" />,
    text: 'Toma decisiones con lógica, no emoción'
  }];
  return <main className="min-h-screen w-full bg-brand-bg text-brand-text font-sans selection:bg-brand-gold/30 selection:text-brand-gold flex items-center justify-center p-4 relative overflow-hidden" data-id="element-371">
      {/* Background radial gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,67,0.15)_0%,rgba(10,14,23,1)_70%)] pointer-events-none" data-id="element-372" />

      <motion.div variants={containerVariants} initial="hidden" animate="visible" className="relative z-10 w-full max-w-2xl mx-auto flex flex-col items-center text-center space-y-10" data-id="element-373">
        <motion.div variants={itemVariants} className="space-y-4" data-id="element-374">
          <p className="text-brand-red font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-375">
            Paso 2 de 2
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-gold leading-tight tracking-tight drop-shadow-lg" data-id="element-376">
            Espera… esto puede cambiar completamente cómo apuestas
          </h1>
          <h2 className="text-xl md:text-2xl text-brand-text font-medium leading-relaxed" data-id="element-377">
            Ya tienes el método. Ahora hazlo automático.
          </h2>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-brand-card/80 backdrop-blur-sm border border-brand-gold/20 rounded-2xl p-6 md:p-8 w-full shadow-[0_0_40px_rgba(212,168,67,0.1)]" data-id="element-378">
          <p className="text-lg text-brand-muted mb-8 text-left" data-id="element-379">
            Ya aprendiste a analizar apuestas. Pero hacerlo manualmente toma
            tiempo y causa errores.
          </p>

          <ul className="space-y-4 text-left mb-8" data-id="element-380">
            {bullets.map((bullet, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-381">
                <div className="bg-brand-gold/10 p-2 rounded-lg border border-brand-gold/20" data-id="element-382">
                  {bullet.icon}
                </div>
                <span className="text-lg md:text-xl font-medium text-brand-text" data-id="element-383">
                  {bullet.text}
                </span>
              </li>)}
          </ul>

          <div className="bg-brand-bg/50 rounded-xl p-6 border border-brand-gold/10 mb-8" data-id="element-384">
            <p className="text-xl md:text-2xl font-bold text-brand-text" data-id="element-385">
              Acceso completo a BetIQ —{' '}
              <span className="text-brand-gold" data-id="element-386">$27 pago único</span>
            </p>
          </div>

          <div className="flex flex-col items-center space-y-4" data-id="element-387">
            <button onClick={() => navigate('/betiq-access')} className="relative group overflow-hidden rounded-md font-heading font-bold text-lg md:text-xl bg-brand-gold text-brand-bg px-8 py-5 w-full transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(212,168,67,0.4)]" data-id="element-388">
              <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-389">
                Sí, quiero acceso inmediato
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-390" />
            </button>

            <button onClick={() => navigate('/downsell')} className="text-brand-muted hover:text-brand-text text-sm md:text-base underline underline-offset-4 transition-colors duration-200 mt-4" data-id="element-391">
              No, prefiero hacerlo manual
            </button>
          </div>
        </motion.div>
      </motion.div>
    </main>;
}